import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_NIRVANA } from '../../../webcomponents.constants';
import IntegrationsGridViewDataProvider from '../dataProvider/IntegrationsGridViewDataProvider';

export default class IntegrationsGridDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();

    this.map.set(API_TYPE_NIRVANA, IntegrationsGridViewDataProvider);
  }
}
